import { useState } from "react";

import { Modal } from "../../components/dashboard/Modal";
import { useToast } from "../../contexts/ToastContext";
import { extractErrorMessage } from "../../lib/api";
import { changePassword } from "../../lib/dashboardApi";

interface PasswordModalProps {
  open: boolean;
  onClose: () => void;
}

export function PasswordModal({ open, onClose }: PasswordModalProps) {
  const { toast } = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  function reset() {
    setCurrent("");
    setNext("");
    setConfirm("");
    setError("");
  }

  async function handleSubmit() {
    setError("");
    if (next.length < 8) {
      setError("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await changePassword(current, next);
      toast("Password updated.");
      reset();
      onClose();
    } catch (e) {
      setError(extractErrorMessage(e, "Could not update password."));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => {
        reset();
        onClose();
      }}
      ariaLabel="Change password"
    >
      <h3>Change Password</h3>
      {error && <div className="form-error" style={{ display: "block", marginBottom: 12 }}>{error}</div>}
      <div className="form-group">
        <label htmlFor="pw-current">Current Password</label>
        <input
          id="pw-current"
          className="form-input"
          type="password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="pw-new">New Password</label>
        <input
          id="pw-new"
          className="form-input"
          type="password"
          placeholder="At least 8 characters"
          value={next}
          onChange={(e) => setNext(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="pw-confirm">Confirm New Password</label>
        <input
          id="pw-confirm"
          className="form-input"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
      </div>
      <div className="modal-actions">
        <button
          type="button"
          className="btn btn-outline"
          onClick={() => {
            reset();
            onClose();
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={submitting}
          onClick={handleSubmit}
        >
          {submitting ? "Updating…" : "Update Password"}
        </button>
      </div>
    </Modal>
  );
}
